import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, Router } from "react-router-dom";
import Login from "./pages/Login"
import Dashboard from "./pages/Dashboard"
import Project from "./pages/Project"
import Items from "./pages/Items"
import Panels from "./pages/Panels"
import ComingSoon from "./pages/ComingSoon"


function App() {
  const token = localStorage.getItem('accessToken');

  if(!token) {
    return <Login />
  }

  return (
    <BrowserRouter>
    <Routes>
      <Route path="/">
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/items" element={<Items />} />
        <Route path="/project/:id" element={<Project />} />
        <Route path="/panels" element={<Panels />} />
        <Route path="/coming-sooon" element={<ComingSoon />} />
        
      </Route>
    </Routes>
  </BrowserRouter>
  );
}

export default App;
